/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AddPossibleAnswerCommand
 */
export interface AddPossibleAnswerCommand {
    /**
     * Answer key/code
     * @type {string}
     * @memberof AddPossibleAnswerCommand
     */
    key: string;
    /**
     * Answer label/text
     * @type {string}
     * @memberof AddPossibleAnswerCommand
     */
    label: string;
    /**
     * Type of value for this answer
     * @type {string}
     * @memberof AddPossibleAnswerCommand
     */
    valueType: string;
    /**
     * Display order of the answer
     * @type {number}
     * @memberof AddPossibleAnswerCommand
     */
    displayOrder: number;
    /**
     * Icon key for the answer
     * @type {string}
     * @memberof AddPossibleAnswerCommand
     */
    iconKey?: string | null;
    /**
     * Whether this answer has child answers
     * @type {boolean}
     * @memberof AddPossibleAnswerCommand
     */
    hasChildren?: boolean;
    /**
     * Additional data for the answer value
     * @type {object}
     * @memberof AddPossibleAnswerCommand
     */
    valueData?: object | null;
}

/**
 * Check if a given object implements the AddPossibleAnswerCommand interface.
 */
export function instanceOfAddPossibleAnswerCommand(value: object): value is AddPossibleAnswerCommand {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('label' in value) || value['label'] === undefined) return false;
    if (!('valueType' in value) || value['valueType'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    return true;
}

export function AddPossibleAnswerCommandFromJSON(json: any): AddPossibleAnswerCommand {
    return AddPossibleAnswerCommandFromJSONTyped(json, false);
}

export function AddPossibleAnswerCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddPossibleAnswerCommand {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'label': json['label'],
        'valueType': json['valueType'],
        'displayOrder': json['displayOrder'],
        'iconKey': json['iconKey'] == null ? undefined : json['iconKey'],
        'hasChildren': json['hasChildren'] == null ? undefined : json['hasChildren'],
        'valueData': json['valueData'] == null ? undefined : json['valueData'],
    };
}

export function AddPossibleAnswerCommandToJSON(json: any): AddPossibleAnswerCommand {
    return AddPossibleAnswerCommandToJSONTyped(json, false);
}

export function AddPossibleAnswerCommandToJSONTyped(value?: AddPossibleAnswerCommand | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'label': value['label'],
        'valueType': value['valueType'],
        'displayOrder': value['displayOrder'],
        'iconKey': value['iconKey'],
        'hasChildren': value['hasChildren'],
        'valueData': value['valueData'],
    };
}

